import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import ResourcesSidebar from "./ResourceSidebar";
import { Biscuit, Notification, getAllUrlParams } from "../../../../utils";
import * as AU from "../../../../utils/Autobahn";
import moment from "moment";
import { $, _, GoogleMaps, autobahn } from "../../../../../vendor";
import * as FileSaver from "../../../../../vendor/FileSaver";
import {
  chartsActions,
  locationActions,
  resourcesActions,
  contingentsActions,
  useSelector,
  ilockitActions,
  webFEActions,
} from "inbooma-api";
import { getContentModifications } from "../../../../App";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import SortNav from "../../../components/SortNav";
import NextPageBtn from "../../../components/NextPageBtn";
import ResourcesList from "./ResourcesList";
import ItemView from "./ItemView";
import ItemViewService from "./ItemViewService";
import { getApiHost, getEnv } from "../../../../Sync";
import { ApiRequester } from "../../../helpers/ApiRequest";
import ChangeLogDialog from "../../../components/ChangeLogDialog";
import Paginator from "../../../components/paginator";

const ResourcesView = (props) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  const allUrlParamsClone = { ...allUrlParams };
  allUrlParams?.location_name !== null && delete allUrlParams.location_name;
  allUrlParams?.q !== undefined && delete allUrlParams.q;
  let language = Biscuit.get("user.lang").replace("-", "_");
  const [initialized, setInitialized] = useState(false);
  const [filter, setFilter] = useState(function () {
    let f = { find: "WithCoordinates" };
    if (allUrlParams?.page !== undefined) {
      f.page = allUrlParams?.page;
    }
    return f;
  });
  const [sort, setSort] = useState({
    sort: "resource_nbr",
    direction: "desc",
  });
  const paginationLimit = 20;
  const [pagination, setPagination] = useState({
    has_next_page: false,
    current_page: 1,
  });

  const _resources = useSelector((state) => state["resources_data"].getResources);
  const [resourcesPending, setResourcesPending] = useState(false);
  const [resources, setResources] = useState([]);
  let resArray = [];
  const _resourceSummary = useSelector((state) => state.resources_data.getResourceSummary);
  const [summaryPending, setSummaryPending] = useState(false);
  const [summary, setSummary] = useState([]);
  const [index, setIndex] = useState(null);

  const [changelogOpen, setChangelogOpen] = useState(false);
  const [changelog, setChangelog] = useState([]);
  const _resource = useSelector((state) => state.resources_data.getResource);
  const _deleteResource = useSelector((state) => state.resources_data.deleteResource);
  const [resourcePending, setResourcePending] = useState(false);
  const [resource, setResource] = useState([]);
  const [positions, setPositions] = useState(null);
  const [mapReference, setMapReference] = useState(null);
  const [map, setMap] = useState(null);
  const [mapStatus, setMapStatus] = useState(0);
  const [mapOffset, setMapOffset] = useState(0);
  const [markers, setMarkers] = useState([]);
  const [geofence, setGeofence] = useState(null);
  const [geofenceInfo, setGeofenceInfo] = useState(null);
  const [selectedGpsResource, setSelectedGpsResource] = useState(null);
  const [trackingMapPosition, setTrackingMapPosition] = useState(null);
  const [gpsTimestamp, setGpsTimestamp] = useState(null);
  const [positionsSet, setPositionsSet] = useState(false);
  let searchOption = null;
  if (allUrlParams?.name !== undefined) {
    searchOption = "name";
  }
  if (allUrlParams?.advertiser !== undefined) {
    searchOption = "advertiser";
  }
  if (allUrlParams?.resource_nbr !== undefined) {
    searchOption = "resource_nbr";
  }
  if (allUrlParams?.external_resource_id !== undefined) {
    searchOption = "external_resource_id";
  }
  if (allUrlParams?.note !== undefined) {
    searchOption = "note";
  }
  const [searchbarOptionsSelected, setSearchBarOptionsSelected] = useState(searchOption);

  const searchbarOptions = [
    { id: null, name: t("all") },
    { id: "name", name: t("name") },
    { id: "advertiser", name: t("advertiser") },
    { id: "resource_nbr", name: t("resource_nbr") },
    { id: "external_resource_id", name: t("external resource id") },
    { id: "note", name: t("note") },
  ];

  const _locations = useSelector((state) => state.locations_data.locations);
  const [locations, setLocations] = useState([]);
  const [locationsPending, setLocationsPending] = useState(false);

  const _contingents = useSelector((state) => state.contingents_data.contingents);
  const [contingents, setContingents] = useState([]);
  const [contingentsPending, setContingentsPending] = useState(false);

  const [resetFilter, setResetFilter] = useState(false);

  const [add, setAdd] = useState(false);

  const _queryState = {
    timeStamp: 0,
    value: "",
  };
  /* let connection = new autobahn.Connection({url: 'ws://test-invoice.inbooma.net:8080', realm: 'realm1'});
     connection.onopen = function (session) {

         // 1) subscribe to a topic
         function onevent(args) {
             console.log(args);
         }
         session.subscribe(Biscuit.get('user.id'), onevent);

         // 2) publish an event
        // session.publish('com.myapp.hello', ['Hello, world!']);

         // 3) register a procedure for remoting
       /!*  function add2(args) {
             return args[0] + args[1];
         }
         session.register('com.myapp.add2', add2);

         // 4) call a remote procedure
         session.call('com.myapp.add2', [2, 3]).then(
             function (res) {
                 console.log("Result:", res);
             }
         );*!/
     };

     connection.open();*/

  useEffect(() => {
    setMapRefer();
    window.onscroll = () => {
      setMapOffset(window.pageYOffset);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (_deleteResource.success == "" || !resourcesPending) {
      return;
    }
    if (_deleteResource.success === true) {
      props.dispatch(resourcesActions.getResourcesResetData());
      let currentURL = currentUrl.search;
      let returnUrl = `/resources${currentURL}`;
      window.location.replace(returnUrl);
    } else {
      showNotification(
        "warning",
        null,
        "Resource konnte nicht gelöscht werden. API Message: " + _deleteResource.data.message,
      );
    }
    setResourcesPending(false);
  }, [_deleteResource]);

  useEffect(() => {
    if (positions === null || !positionsSet) return;
    // create geofence of location on map
    // set geofence
    console.log("mapreference", mapReference);
    console.log("positions", positions);
    setTimeout(waitForMapReference, 250);
    let waits = 0;
    function waitForMapReference() {
      waits++;
      if (mapReference !== null) {
        let geofenceLocal = new mapReference.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          map: map,
          center:
            positions?.location !== null
              ? { lat: positions?.location?.latitude, lng: positions?.location?.longitude }
              : { lat: positions?.latitude, lng: positions?.longitude },
          radius:
            positions?.location !== null ? positions?.location?.geofence : positions?.geofence, // value in meter
        });

        // set infowindow for geofence

        let infoWindow = new mapReference.maps.InfoWindow({
          content: positions?.location !== null ? positions?.location?.name : "",
        });
        // use offset to put the infobox to the top of the geofence
        if (typeof geofenceLocal.getCenter() !== "undefined") {
          infoWindow.setPosition(
            new mapReference.maps.LatLng(
              geofenceLocal.getCenter().lat() + 0.00045,
              geofenceLocal.getCenter().lng(),
            ),
          );
          setGeofence(geofenceLocal);
        }
        infoWindow.open(map, null);

        setGeofenceInfo(infoWindow);
        // finished fetching tracking data?
      } else {
        console.log("waits", waits);
        if (waits === 3) {
          setMapRefer();
          waits = 0;
        }
        setTimeout(waitForMapReference, 250);
      }
    }
    setPositionsSet(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [positionsSet, positions, trackingMapPosition]);

  useEffect(() => {
    console.log("trackingMapPosition", trackingMapPosition);
    console.log("geofence", geofence);
    if (geofence === null) return;
    if (
      trackingMapPosition !== null &&
      typeof trackingMapPosition.status !== "undefined" &&
      trackingMapPosition.status != null
    ) {
      if (trackingMapPosition.lat != null && trackingMapPosition.lng != null) {
        drawGpsMarker(
          {
            lat: positions?.location?.latitude,
            lng: positions?.location?.longitude,
          },
          {
            lat: trackingMapPosition.lat,
            lng: trackingMapPosition.lng,
          },
          geofence,
        );
      } else {
        drawGpsMarker(null, null, geofence);
      }
    }
  }, [trackingMapPosition, geofence]);

  useEffect(() => {
    if (_locations.success === "") return;

    if (_locations.success === true && _locations.data.length) {
      let ld = [];
      _locations.data.map((l) => {
        ld[l.id] = l;
      });
      setLocations(ld);
    } else if (_locations.success === false) {
      console.log("Failed to request locations!");
    }
    setLocationsPending(false);
    if (!contingentsPending && !resourcesPending && !resourcePending && !summaryPending) {
      setInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_locations]);

  useEffect(() => {
    if (_contingents.success === "") return;

    if (_contingents.success === true && _contingents.data.length) {
      setContingents(_contingents.data);
    } else if (_contingents.success === false) {
      console.log("Failed to request locations!");
    }
    setContingentsPending(false);
    if (!locationsPending && !resourcesPending && !resourcePending && !summaryPending) {
      setInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_contingents]);

  useEffect(() => {
    if (resourcePending === false || _resource.success === "") {
      return;
    }
    if (_resource.success === true) {
      setResource(_resource.data);
      //setIndex(_resource.data.id);
    } else {
      console.log("Failed fetching resource!");
    }
    setResourcePending(false);

    if (!locationsPending && !resourcesPending && !contingentsPending && !summaryPending) {
      setInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_resource]);

  useEffect(() => {
    if (summaryPending === false || _resourceSummary.success === "") {
      return;
    }
    if (_resourceSummary.success === true) {
      setSummary(_resourceSummary.data);
    } else {
      console.log("Failed fetching summary!");
    }
    setSummaryPending(false);
    if (!locationsPending && !resourcesPending && !contingentsPending && !resourcePending) {
      setInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_resourceSummary]);

  useEffect(() => {
    if (resourcesPending === false || _resources.success === "") {
      return;
    }

    if (_resources.success === true) {
      setResources(_resources.data);
      setPagination({ ..._resources.pagination });
    } else {
      console.log("Failed fetching resources!");
    }
    setResourcesPending(false);
    if (!locationsPending && !resourcePending && !contingentsPending && !summaryPending) {
      setInitialized(true);
    }
    $(window).scrollTop(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_resources]);

  useEffect(() => {
    if (resourcesPending || summaryPending) return;
    props.dispatch(
      resourcesActions.getResourceSummary({
        token: Biscuit.get("token"),
        filter: filter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setSummaryPending(true);
    if (!locationsPending && !resourcePending && !contingentsPending && !resourcesPending) {
      setInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resources]);

  const onCloseResource = () => {};

  const onLocationQueryHandle = (query) => {
    // start dispatch of location query
    props.dispatch(
      locationActions.getLocations({
        token: Biscuit.get("token"),
        filter: {
          findForSelect: true,
          find: "short",
          limit: 999,
          page: 1,
          q: query,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setLocationsPending(true);
    setInitialized(false);
  };

  const openResourceGPS = (resource) => {
    setMapRefer();

    // get location to draw geofence
    const fetchPositions = async () => {
      const response = await ApiRequester("/resources/getPositions/" + resource.id)();
      const data = response.data;
      setPositions(data);
      setPositionsSet(true);
      if (typeof data.position !== "undefined") {
        setTrackingMapPosition({
          lat: data.position.latitude,
          lng: data.position.longitude,
          status: data.position.status,
        });
        if (typeof geofence !== "undefined" && geofence != null) {
          drawGpsMarker(
            {
              lat: geofence.center.lat(),
              lng: geofence.center.lng(),
            },
            {
              lat: data.position.latitude,
              lng: data.position.longitude,
            },
            geofence,
          );
        }
        setGpsTimestamp(data.position.serverTime);
      } else {
        // no position data at all
        console.log("no gps data available");
        setTrackingMapPosition({ lat: null, lng: null, status: "unknown" }); // dummy latlng to indicate that tracking has been finished
        if (typeof geofence !== "undefined" && geofence != null) {
          // execute only if location request has already been finished
          drawGpsMarker(null, null, geofence);
        }
      }
    };

    // close old infowindow if exist and center map
    if (geofenceInfo != null) geofenceInfo.setMap(null);
    if (map !== null && resource.latitude !== null && resource.longitude !== null) {
      map.setCenter({ lat: resource.latitude, lng: resource.longitude });
    }
    fetchPositions();
    setMapStatus(2); // show map
    setSelectedGpsResource(resource);
  };

  // draws app and gps marker depending on arguments, set map status
  const drawGpsMarker = (locPos, gpsPos, _geofence) => {
    console.log("draw marker: ", _geofence);
    console.log("locPos", locPos);
    console.log("gpsPos", gpsPos);
    let gpsMarkerIcon, mapState, appMarker, gpsMarker;
    let distanceGps, distanceApp;
    let _markers = [...markers];

    if (
      typeof locPos === "undefined" ||
      locPos == null ||
      typeof gpsPos === "undefined" ||
      gpsPos == null
    ) {
      mapState = 6; // no GPS data
    } else if (selectedGpsResource.checkedInStatus === "inprogress") {
      gpsMarkerIcon = "https://maps.google.com/mapfiles/ms/icons/orange-dot.png";
      mapState = 5; // bike on tour
    } else {
      // compute distance to GPS position
      setTimeout(waitForGeometryLibraries, 250);
      function waitForGeometryLibraries() {
        if (typeof google.maps.geometry !== "undefined") {
          console.log("geometry is not undefined");
          distanceGps = mapReference.maps.geometry.spherical.computeDistanceBetween(
            new mapReference.maps.LatLng(locPos.lat, locPos.lng),
            new mapReference.maps.LatLng(gpsPos.lat, gpsPos.lng),
          );
          // compute distance to GPS position
          distanceApp = mapReference.maps.geometry.spherical.computeDistanceBetween(
            new mapReference.maps.LatLng(locPos.lat, locPos.lng),
            new mapReference.maps.LatLng(
              selectedGpsResource.latitude,
              selectedGpsResource.longitude,
            ),
          );
          console.log("distanceGps", distanceGps);
          console.log("distanceApp", distanceApp);
          console.log("geofence", geofence);
          if (distanceGps <= geofence.radius && distanceApp <= geofence.radius) {
            gpsMarkerIcon = "https://maps.google.com/mapfiles/ms/icons/green-dot.png";
            mapState = 4; // all in geofence -> only gps green marker
          } else {
            gpsMarkerIcon = "https://maps.google.com/mapfiles/ms/icons/red-dot.png";
            mapState = 3; // problem with GPS position
          }
        } else {
          setTimeout(waitForGeometryLibraries, 250);
        }
      }
    }
    setTimeout(waitForMapState, 250);
    function waitForMapState() {
      if (typeof mapState !== "undefined") {
        console.log("mapState !== 'undefined'");
        console.log("mapState: ", mapState);
        console.log("selectedGpsResource", selectedGpsResource);
        console.log("gpsPos", gpsPos);
        if (mapState > 2 && mapState !== 4) {
          // draw app marker
          if (selectedGpsResource.latitude !== null && selectedGpsResource.longitude !== null) {
            appMarker = new mapReference.maps.Marker({
              // set new marker if location is valid
              map: map,
              position: {
                lat: selectedGpsResource.latitude,
                lng: selectedGpsResource.longitude,
              },
              icon: {
                url: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
              },
              draggable: false,
            });

            _markers.push(appMarker);
          }
        }
        // draw gps marker
        if (mapState > 2 && mapState !== 6) {
          gpsMarker = new mapReference.maps.Marker({
            // set new marker if location is valid
            map: map,
            position: {
              lat: gpsPos.lat,
              lng: gpsPos.lng,
            },
            icon: {
              url: gpsMarkerIcon,
            },
            draggable: false,
          });

          _markers.push(gpsMarker);
        }

        setMarkers(_markers);

        // set center and zoom
        let bounds = new mapReference.maps.LatLngBounds();
        if (mapState === 6 && typeof appMarker !== "undefined") {
          // center on app marker because it's the only one
          map.setCenter({ lat: selectedGpsResource.latitude, lng: selectedGpsResource.longitude });
          bounds.extend(appMarker.getPosition());
          bounds.extend(_geofence.getCenter());
          //map.setZoom(17);
        } else if (mapState === 4 && typeof gpsMarker !== "undefined") {
          // center on gps marker because it's the only one
          map.setCenter({ lat: gpsPos.lat, lng: gpsPos.lng });
          bounds.extend(_geofence.getCenter());
          bounds.extend(gpsMarker.getPosition());
          //map.setZoom(17);
        } else {
          // use bounds to center map on both markers

          if (typeof appMarker !== "undefined") {
            bounds.extend(appMarker.getPosition());
          }
          bounds.extend(gpsMarker.getPosition());
          bounds.extend(_geofence.getCenter());
        }
        map.fitBounds(bounds, { top: 50, bottom: 50, left: 50, right: 50 });
        setMapStatus(mapState); // re-render map
      } else {
        setTimeout(waitForMapState, 250);
      }
    }
  };

  const onCloseMap = () => {
    setMapStatus(1); // hide map

    if (geofence !== null) {
      geofence.setMap(null); // remove geofence from map
      setGeofence(null); // remove old geofence
    }
    setTrackingMapPosition(null); // remove old gps position

    // reset markers
    for (let i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
    setPositionsSet(false);
    setPositions(null);
    setMarkers([]);
  };

  const loadNextPage = (page) => {
    setResourcesPending(true);

    let requestFilter = { ...filter };
    requestFilter.sort = sort.sort;
    requestFilter.direction = sort.direction;
    requestFilter.limit = paginationLimit;
    requestFilter.page = page;
    if (typeof requestFilter.find === "undefined") {
      requestFilter.find = "WithCoordinates";
    }
    if (page > 1) {
      searchParams.set("page", page);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      searchParams.delete("page");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    // fetch next page
    props.dispatch(
      resourcesActions.getResources({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
  };

  const filterChangedHandle = (filter, sorts = null) => {
    let requestFilter = { ...filter };
    if (sorts === null) {
      sorts = sort;
    } else {
      setSort(sorts);
    }
    requestFilter.sort = sorts.sort;
    requestFilter.direction = sorts.direction;
    if (typeof filter.limit !== "undefined") {
      requestFilter.limit = filter.limit;
      if (typeof requestFilter.page !== "undefined") {
        delete requestFilter.page;
      }
    } else {
      requestFilter.limit = paginationLimit;
      requestFilter.page = 1;
    }
    if (typeof filter.find === "undefined") {
      requestFilter.find = "WithCoordinates";
    }

    props.dispatch(
      resourcesActions.getResources({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setResourcesPending(true);
    setFilter(filter);
  };

  const onSortChangedHandle = (ev) => {
    const el = ev.currentTarget;
    const sortKey = el.getAttribute("data-inb-val"),
      direction = el.getAttribute("data-inb-direction"),
      isOppositeElement = direction === null && el.classList.contains("is-active"),
      newDirection = direction === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      let requestFilter;
      if (typeof filter.limit !== "undefined") {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
        };
      } else {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
          limit: paginationLimit,
          page: 1,
        };
      }
      props.dispatch(
        resourcesActions.getResources({
          token: Biscuit.get("token"),
          suffix: "",
          filter: requestFilter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setResourcesPending(true);
      setSort({
        sort: sortKey,
        direction: direction,
      });

      const activeSortTab = $(".is-active");
      _.each(activeSortTab, function (key, value) {
        key.classList.remove("is-active");
      });
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }
  };

  const searchBarHandler = (ev) => {
    let query;
    if (typeof ev.target !== "undefined") {
      query = ev.target.value.toLowerCase();
    } else {
      if (typeof ev === "string") {
        query = ev;
      } else {
        query = "";
      }
    }
    searchParams.delete("q");
    searchParams.delete("id");
    searchParams.delete("find");
    searchParams.delete("location_name");
    searchParams.delete("location_id");
    searchParams.delete("contingent_id");
    searchParams.delete("resource_id");
    searchParams.delete("external_resource_id");
    searchParams.delete("resource_nbr");
    searchParams.delete("advertiser");
    searchParams.delete("note");
    searchParams.delete("name");
    allUrlParams?.location_name !== null && delete allUrlParams.location_name;
    allUrlParams?.q !== undefined && delete allUrlParams.q;
    allUrlParams?.location_id !== null && delete allUrlParams.location_id;
    allUrlParams?.find !== undefined && delete allUrlParams.find;
    allUrlParams?.contingent_id !== null && delete allUrlParams.contingent_id;
    allUrlParams?.resource_id !== null && delete allUrlParams.resource_id;
    allUrlParams?.resource_nbr !== null && delete allUrlParams.resource_nbr;
    allUrlParams?.advertiser !== null && delete allUrlParams.advertiser;
    allUrlParams?.note !== null && delete allUrlParams.note;
    allUrlParams?.external_resource_id !== null && delete allUrlParams.external_resource_id;
    allUrlParams?.name !== null && delete allUrlParams.name;
    if (query !== "") {
      if (searchbarOptionsSelected !== null) {
        searchParams.set(searchbarOptionsSelected, query);
      }
      searchParams.set("q", query);
    }
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
    let standardFilter = {
      sort: "resource_nbr",
      direction: "desc",
      find: "WithCoordinates",
      page: 1,
      limit: 40,
      ...allUrlParams,
    };
    const minLength = 1;
    let filterA = standardFilter;
    setResetFilter(true);
    if (query.length >= minLength && searchbarOptionsSelected === null) {
      // work user search only for values bigger or equal to the minimum length

      setTimeout(function () {
        let diff = Number(moment().format("x")) - _queryState.timeStamp;

        if (diff > 700 && _queryState.value === query) {
          // no changes after the last 700 ms -> user finished input -> start request
          filterChangedHandle({
            ...filterA,
            q: query,
          });
        }
      }, 800);
    } else if (query.length >= minLength && searchbarOptionsSelected !== null) {
      let cloneA = {};
      Object.assign(cloneA, filterA);
      cloneA[searchbarOptionsSelected] = query;
      filterChangedHandle(cloneA);
    } else {
      filterChangedHandle(filterA);
    }
    _queryState.timeStamp = Number(moment().format("x"));
    _queryState.value = query;
  };

  const initialize = () => {
    if (
      initialized ||
      resourcesPending ||
      contingentsPending ||
      locationsPending ||
      resourcePending ||
      summaryPending
    )
      return;

    let requestFilter = { ...filter };
    requestFilter = { ...requestFilter, page: 1 };
    requestFilter = { ...requestFilter, limit: paginationLimit };
    requestFilter = { ...requestFilter, sort: sort.sort };
    requestFilter = { ...requestFilter, direction: sort.direction };
    requestFilter = { ...requestFilter, ...allUrlParams };
    if (
      props.params !== null &&
      typeof props.params[1] !== "undefined" &&
      props.params[0] === "id"
    ) {
      requestFilter = { ...requestFilter, id: props.params[1] };
    }
    if (
      props.params !== null &&
      typeof props.params[1] !== "undefined" &&
      props.params[0] === "status" &&
      props.params[1] === "inprogress"
    ) {
      requestFilter = { ...requestFilter, find: props.params[1] };
    }
    if (allUrlParamsClone?.q !== undefined) {
      if (searchbarOptionsSelected === null) {
        requestFilter = { ...filter, q: allUrlParamsClone?.q };
      } else {
        requestFilter[searchbarOptionsSelected] = allUrlParamsClone?.q;
      }
    }

    props.dispatch(
      locationActions.getLocations({
        token: Biscuit.get("token"),
        filter: {
          findForSelect: true,
          limit: 1000,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setLocationsPending(true);
    props.dispatch(
      contingentsActions.getContingents({
        token: Biscuit.get("token"),
        filter: {
          findForSelect: true,
          limit: 1000,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setContingentsPending(true);
    if (
      props.params !== null &&
      !(location.pathname.indexOf("resources/add") >= 0) &&
      typeof props.params[0] !== "undefined" &&
      props.params[0] !== "add" &&
      props.params[0] !== "id" &&
      props.params[0] !== "status" &&
      props.params[0] !== "location_id" &&
      props.params[0] !== "location_name" &&
      props.params[0] !== "page" &&
      props.params[0] !== "contingent_id" &&
      props.params[0] !== "q" &&
      props.params[0] !== "find" &&
      props.params[0] !== "note" &&
      props.params[0] !== "advertiser" &&
      props.params[0] !== "name" &&
      props.params[0] !== "resource_nbr" &&
      props.params[0] !== "external_resource_id"
    ) {
      props.dispatch(
        resourcesActions.getResource({
          token: Biscuit.get("token"),
          id: props.params[0],
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setResourcePending(true);
    } else {
      props.dispatch(
        resourcesActions.getResources({
          token: Biscuit.get("token"),
          suffix: "",
          filter: requestFilter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setResourcesPending(true);
    }
    setPositionsSet(false);
    setPositions(null);
    // Init map and pass it as reference to childViews

    // Free from memory
    if (document.getElementById("map")) {
      console.log("map already exists!");
      // remove existing instance of map
      //  that._mapReference.maps.event.clearInstanceListeners(document.getElementById('map'));
      return;
    }

    //GoogleMaps.KEY = settings.GOOGLE_MAPS_API_KEY;
    setMapRefer();

    //setInitialized(true);
  };

  const setMapRefer = () => {
    GoogleMaps.KEY = "AIzaSyA7nXDt2yy8x347fyUHd_TM8bEKN5dLfS0"; //'AIzaSyA-KYu6ZYUf3ISccsHsweCIGMKNn0jrefY';//'AIzaSyA7nXDt2yy8x347fyUHd_TM8bEKN5dLfS0';
    GoogleMaps.VERSION = "weekly";

    GoogleMaps.load(function (google) {
      if (document.getElementById("inb-resources-locations-map") == null || mapStatus > 0) return;

      setMapReference(google);

      setMap(
        new google.maps.Map(document.getElementById("inb-resources-locations-map"), {
          zoom: 12,
          maxZoom: 17,
          mapTypeControlOptions: { mapTypeIds: [] },
        }),
      );

      // fetch iLockIt device list
      props.dispatch(
        chartsActions.getDevices({
          token: Biscuit.get("token"),
        }),
      );

      setMapStatus(1);
    });
  };
  if (!initialized) initialize();

  const _exchangeLabel = (value) => {
    let cm = getContentModifications();
    if (cm.labels != null) {
      if (cm.labels[value] !== undefined) {
        return cm.labels[value];
      }
    }
    return value;
  };

  const showNotification = (msgType, itemId, apiMsg = "", type = "resource") => {
    // little delay necessary to make notifications visible (render of background must be done before)
    setTimeout(() => {
      if (msgType === "success") {
        new Notification({
          message:
            apiMsg !== "" ? apiMsg : t("saved_${a}", { a: t(type) }, "capital") + " #" + itemId,
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-check",
        });
      } else if (msgType === "warning") {
        new Notification({
          message:
            typeof apiMsg !== "undefined" && apiMsg !== null
              ? t(apiMsg, null, "capital")
              : t("request_error", null, "capital"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });
      }
    }, 200);
  };
  const onRemoveResource = (resource) => {
    if (confirm(t("really_remove"))) {
      props.dispatch(
        resourcesActions.deleteResource({
          resource_id: Number(resource.id),
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setResourcesPending(true);
    }
  };

  let tabs = [
    {
      name: t("id"),
      mediumWidth: 1,
      smallWidth: 2,
      title: t("sort_by_${a}", { a: t("resource_nbr") }),
      canSort: true,
      extraClasses: "inb-order-big padding-1",
      sort: {
        direction: "desc",
        data_inb_val: "resource_nbr",
      },
    },
    {
      name: t("name", null, "capital"),
      mediumWidth: 2,
      smallWidth: 1,
      title: t("sort_by_${a}", { a: t("name") }),
      canSort: true,
      extraClasses: "inb-order-big",
      sort: {
        direction: null,
        data_inb_val: "name",
      },
    },
    {
      name: t("contingent", null, "capital"),
      mediumWidth: 1,
      smallWidth: 2,
      extraClasses: "inb-order-big",
      title: t("contingent", null, "capital"),
      canSort: false,
    },
    {
      name: t("location", null, "capital"),
      mediumWidth: 2,
      smallWidth: 2,
      extraClasses: "inb-order-big",
      title: t("location", null, "capital"),
      canSort: true,
      sort: {
        direction: null,
        data_inb_val: "location_id",
      },
    },
    {
      name: t("Check-in", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      extraClasses: "inb-order-big padding-1",
      title: t("sort_by_${a}", { a: t("Check-in") }),
      canSort: true,
      sort: {
        direction: null,
        data_inb_val: "checkInAmount",
      },
    },
    {
      name: "",
      mediumWidth: 2,
      smallWidth: 2,
      title: t("akkus", null, "capital"),
      canSort: false,
    },
    {
      name: t("status", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      title: t("sort_by_${a}", { a: t("status") }),
      canSort: true,
      sort: {
        direction: null,
        data_inb_val: "status",
      },
    },
    {
      name: t("updated", null, "capital"),
      mediumWidth: 1,
      smallWidth: 1,
      title: t("sort_by_${a}", { a: t("last_modified_at") }),
      canSort: true,
      sort: {
        direction: null,
        data_inb_val: "modified",
      },
    },
  ];
  const openChangeLog = (ev) => {
    setChangelog(ev);
    setChangelogOpen(true);
  };
  const handleCloseDialog = () => {
    setChangelogOpen(false);
  };
  console.log("mapStatus", mapStatus);
  return (
    <>
      {initialized && (
        <ResourcesSidebar
          dispatch={props.dispatch}
          heading={
            Biscuit.get("client.isVehicleOwner") === "true"
              ? t("Fahrzeuge")
              : Biscuit.get("client.isBikeSharing") === "true"
                ? t("Bikesharing")
                : Biscuit.get("client.hasAppointments") === "true"
                  ? t("Termine")
                  : Biscuit.get("client.hasParkingLots") === "true"
                    ? t("ParkingLots")
                    : t("resources", null, "capital")
          }
          filterChangedHandle={filterChangedHandle}
          filter={filter}
          setFilter={setFilter}
          summaryPending={summaryPending}
          resetFilter={resetFilter}
          setResetFilter={setResetFilter}
          locations={locations}
          contingents={contingents}
          sort={sort}
          summary={summary}
          setAdd={setAdd}
          onLocationQueryHandle={onLocationQueryHandle}
        />
      )}
      <div id="inb-c-main" className="columns resource">
        {(typeof mapStatus === "undefined" || mapStatus === null || mapStatus === 1) && (
          <InboomaSubmenu
            searchbar={
              typeof mapStatus === "undefined" || mapStatus === null || mapStatus === 1
                ? true
                : null
            }
            searchbarPlaceholder={t("name") + " / " + t("resource_nbr") + " / ..."}
            searchbarOptions={searchbarOptions}
            searchBarOptionsSelected={searchbarOptionsSelected}
            setSearchBarOptionsSelected={setSearchBarOptionsSelected}
            extraClasses={"sticky-top"}
            searchbarValue={allUrlParamsClone?.q !== undefined ? allUrlParamsClone.q : ""}
            searchbarHandler={searchBarHandler}
            smallOnlyTitle={
              Biscuit.get("client.isVehicleOwner") === "true"
                ? t("Fahrzeuge")
                : Biscuit.get("client.isBikeSharing") === "true"
                  ? t("Bikesharing")
                  : Biscuit.get("client.hasAppointments") === "true"
                    ? t("Termine")
                    : Biscuit.get("client.hasParkingLots") === "true"
                      ? t("ParkingLots")
                      : t("resources", null, "capital")
            }
            pagination={pagination}
            itemsCountPerPage={paginationLimit}
            pageRangeDisplayed={5}
            showPagination={
              typeof mapStatus === "undefined" || mapStatus === null || mapStatus === 1
            }
            onChange={loadNextPage}
            initialized={initialized}
            itemLength={resources.length}
          />
        )}

        <SortNav
          tabs={tabs}
          extraId={"resource-nav"}
          extraClasses={"sticky-top-sortbar"}
          listStyle="tight"
          handler={onSortChangedHandle}
        />
        {/* {initialized && resources.length > 0 && !resourcesPending && typeof pagination !== 'undefined' && mapStatus === 1 &&
                    <Paginator
                    pagination={pagination}
                    itemsCountPerPage={paginationLimit}
                    pageRangeDisplayed={5}
                    onChange={loadNextPage}
                    upper={true}
                    />} */}
        {initialized && resources.length > 0 && !resourcesPending && !add && (
          <ResourcesList
            resources={resources}
            dispatch={props.dispatch}
            _exchangeLabel={_exchangeLabel}
            filterChangedHandle={filterChangedHandle}
            filter={filter}
            key={"inb-c-main-resources"}
            sort={sort}
            setSort={setSort}
            openResourceGPS={openResourceGPS}
            onRemoveResource={onRemoveResource}
            setIndex={setIndex}
            setInitialized={setInitialized}
            openChangeLog={openChangeLog}
            showNotification={showNotification}
          />
        )}
        {initialized && changelogOpen && (
          <ChangeLogDialog
            changeLogs={changelog}
            handleCloseDialog={handleCloseDialog}
            toggleChangeLogs={true}
          />
        )}
        {initialized &&
          (resources.length < 1 || typeof resources.length === "undefined") &&
          !resourcesPending && (
            <>
              <div id="inb-app-collection-empty" className="inb-announcement">
                <div className="inb-image-box">
                  <img src="assets/img/no_data.svg" />
                </div>
                <h3>{t("app_msg_collection_empty")}</h3>
                <p>{t("app_msg_collection_empty_body")}</p>
              </div>
            </>
          )}
        {/* {initialized && resources.length > 0 && !resourcesPending && typeof pagination !== 'undefined' &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                        upper={false}
                    />} */}
        {resourcesPending && (
          <>
            {" "}
            <div id="inb-app-collection-empty" className="inb-announcement">
              <div className="inb-image-box">
                <img className="rollingLoader colorize-black" src="assets/img/rolling_loader.svg" />
              </div>
            </div>
          </>
        )}
        <div
          className={
            mapStatus < 2
              ? "js-off-canvas-overlay is-overlay-fixed"
              : "js-off-canvas-overlay is-overlay-fixed is-visible"
          }
          style={{ zIndex: "1" }}
        >
          {" "}
        </div>
        <div
          className={mapStatus < 2 ? "hide" : ""}
          style={{
            position: "absolute",
            width: "90%",
            height: "80%",
            left: "5%",
            top: "calc(10% + " + mapOffset + "px)",
            zIndex: "2",
            backgroundColor: "white",
          }}
        >
          <div
            style={{ height: "60px", width: "100%", paddingTop: "0.5rem", paddingRight: "0.8rem" }}
          >
            <a>
              <button
                type="button"
                style={{ marginBottom: "0" }}
                className="button hollow secondary right button-abort round"
                title="Fenster schließen"
                onClick={() => onCloseMap()}
              >
                <i className="fi fi-x" style={{ padding: "0" }}>
                  {" "}
                </i>
              </button>
            </a>
          </div>
          <div
            id="inb-resources-locations-map"
            className={"full" + map != null ? "" : " hide"}
            style={{
              position: "relative",
              overflow: "hidden",
              width: "100%",
              height: "calc(100% - 115px)",
            }}
          ></div>
          <div style={{ textAlign: "center", paddingTop: "10px" }}>
            {mapStatus !== 4 && ( // hide app marker if app and gps in geofence
              <div style={{ display: "inline", marginTop: "8px" }}>
                <img src="https://maps.google.com/mapfiles/ms/icons/blue-dot.png" />
                <span>
                  {selectedGpsResource !== null
                    ? selectedGpsResource.geoEvent
                    : t("tracking_app_marker_description", null, "capital")}
                </span>
                <span style={{ fontSize: "0.95em", fontFamily: "monospace" }}>
                  {" "}
                  {selectedGpsResource !== null
                    ? "(" +
                      t("last_update", null, "capital") +
                      ":" +
                      moment(selectedGpsResource.geoDate).format("DD.MM.YYYY HH:mm:ss") +
                      ")"
                    : ""}
                </span>
              </div>
            )}
            {mapStatus === 6 && ( // no GPS
              <div style={{ display: "inline", marginLeft: "5%", marginTop: "8px" }}>
                <span>{t("tracking_position_not_available", null, "capital")}</span>
                {trackingMapPosition !== null &&
                  typeof trackingMapPosition.status !== "undefined" &&
                  trackingMapPosition.status !== null && (
                    <span style={{ fontSize: "0.95em", fontFamily: "monospace" }}>
                      {" (" +
                        t("status", null, "capital") +
                        ": " +
                        trackingMapPosition.status +
                        ")"}
                    </span>
                  )}
              </div>
            )}
            {mapStatus !== 6 && ( // gps position available
              <div style={{ display: "inline", marginLeft: "5%", marginTop: "8px" }}>
                {mapStatus === 4 && ( // gps and app position within geofence, bike available
                  <>
                    <img src="https://maps.google.com/mapfiles/ms/icons/green-dot.png" />
                    <span>{t("tracking_gps_marker_description", null, "capital")}</span>
                  </>
                )}
                {mapStatus === 3 && ( // gps or app position not within geofence, bike available
                  <>
                    <img src="https://maps.google.com/mapfiles/ms/icons/red-dot.png" />
                    <span>{t("tracking_gps_marker_description", null, "capital")}</span>
                  </>
                )}
                {mapStatus === 5 && ( // bike on tour
                  <>
                    <img src="https://maps.google.com/mapfiles/ms/icons/orange-dot.png" />
                    <span>{t("tracking_gps_marker_description", null, "capital")}</span>
                  </>
                )}
                <span style={{ fontSize: "0.95em", fontFamily: "monospace" }}>
                  {" "}
                  (
                  {t("last_update", null, "capital") +
                    ":" +
                    moment(gpsTimestamp).format("DD.MM.YYYY HH:mm:ss")}
                  )
                </span>
              </div>
            )}
          </div>
        </div>

        {((props.params !== null &&
          props.params[0] !== "id" &&
          props.params[0] !== "q" &&
          props.params[0] !== "page" &&
          props.params[0] !== "status" &&
          props.params[0] !== "location_id" &&
          props.params[0] !== "location_name" &&
          props.params[0] !== "contingent_id" &&
          props.params[0] !== "find" &&
          props.params[0] !== "resource_nbr" &&
          props.params[0] !== "advertiser" &&
          props.params[0] !== "external_resource_id" &&
          props.params[0] !== "note" &&
          props.params[0] !== "name" &&
          initialized &&
          !resourcePending) ||
          index !== null ||
          add !== false) && (
          <ItemView
            onClose={onCloseResource}
            dispatch={props.dispatch}
            locations={locations}
            contingents={contingents}
            filterChangedHandle={filterChangedHandle}
            filter={filter}
            showNotification={showNotification}
            requestPath={props.returnPath}
            resource={index !== null ? resources[index] : resource}
            setIndex={setIndex}
            setAdd={setAdd}
            setResource={setResource}
            setResourcesPending={setResourcesPending}
          />
        )}
        {/*       {((props.params !== null && props.params[0] !== 'id' && props.params[0] !== "q" && props.params[0] !== 'status' && props.params[0] !== 'location_id' && props.params[0] !== 'location_name' && props.params[0] !== 'contingent_id' && props.params[0] !== 'find'  && Biscuit.get('user.role') !== 'admin' && initialized && !resourcePending) || index !== null || add !== false)  &&
                <ItemViewService
                    onClose={onCloseResource}
                    dispatch={props.dispatch}
                    locations={locations}
                    contingents={contingents}
                    filterChangedHandle={filterChangedHandle}
                    filter={filter}
                    showNotification={showNotification}
                    requestPath={props.returnPath}
                    resource={index !== null?resources[index]:resource}
                    setIndex={setIndex}
                    setAdd={setAdd}
                    setResource={setResource}
                    setResourcesPending={setResourcesPending}
                />
                }*/}
      </div>
    </>
  );
};

export default ResourcesView;
